import { formatUnits, parseUnits } from "viem";

export const FANZ_DECIMALS = 18;
export const ETH_DECIMALS = 18;
export const STABLE_DECIMALS = 6;
export const PRICE_DECIMALS = 8;

export function formatFanz(value: bigint, fractionDigits = 2): string {
  const s = formatUnits(value, FANZ_DECIMALS);
  const n = Number(s);
  if (!Number.isFinite(n)) return s;
  return n.toLocaleString("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function formatStable(value: bigint, fractionDigits = 2): string {
  const s = formatUnits(value, STABLE_DECIMALS);
  return Number(s).toLocaleString("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function formatEth(value: bigint, fractionDigits = 4): string {
  const s = formatUnits(value, ETH_DECIMALS);
  return Number(s).toLocaleString("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function formatPrice(priceE8: bigint): string {
  const usd = Number(priceE8) / 10 ** PRICE_DECIMALS;
  return usd.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 4,
    maximumFractionDigits: 6,
  });
}

export function parseFanz(s: string): bigint {
  return parseUnits(s, FANZ_DECIMALS);
}

export function parseStable(s: string): bigint {
  return parseUnits(s, STABLE_DECIMALS);
}

export function parseEth(s: string): bigint {
  return parseUnits(s, ETH_DECIMALS);
}

/// Estimate FANZ output for a given USD-cents input at a given priceE8.
/// Mirrors the contract math: fanzOut = (paidUsdE8 * 1e18) / priceE8.
export function estimateFanzOut(paidUsdE8: bigint, priceE8: bigint): bigint {
  if (priceE8 === 0n) return 0n;
  return (paidUsdE8 * 10n ** 18n) / priceE8;
}

/// Estimate USD value for a stable purchase of `amount` (6-decimal stable).
export function stableToUsdE8(amount: bigint): bigint {
  return amount * 100n; // 6 decimals -> 8 decimals
}

/// Estimate USD value for an ETH purchase at a given ethUsdPriceE8.
export function ethToUsdE8(ethWei: bigint, ethUsdPriceE8: bigint): bigint {
  return (ethWei * ethUsdPriceE8) / 10n ** 18n;
}
